module.exports = __WEBPACK_EXTERNAL_MODULE__820__;